var map = {
	"./angle-left.svg": 1859,
	"./angle.svg": 1860,
	"./arc.svg": 1861,
	"./atomic-design.svg": 1862,
	"./calendar.svg": 1863,
	"./check.svg": 1864,
	"./checkbox.svg": 1865,
	"./checkboxActive.svg": 1866,
	"./checkboxCross.svg": 1867,
	"./checkmarkCircle.svg": 1868,
	"./circle.svg": 1869,
	"./circleArrow.svg": 1870,
	"./circleCheck.svg": 1871,
	"./circleCheckBold.svg": 1872,
	"./circleCrossBold.svg": 1873,
	"./clipboardCheck.svg": 1874,
	"./close.svg": 1875,
	"./copy.svg": 1876,
	"./cross.svg": 1877,
	"./dist.svg": 1878,
	"./docs.svg": 1879,
	"./documentText.svg": 1880,
	"./downloadIcon.svg": 1881,
	"./exclamationMark.svg": 1882,
	"./facebook.svg": 1883,
	"./facebook_new.svg": 1884,
	"./forwardArrow.svg": 1885,
	"./github.svg": 1886,
	"./google.svg": 1887,
	"./heart.svg": 1888,
	"./home.svg": 1889,
	"./info.svg": 1890,
	"./instagram.svg": 1891,
	"./jest.svg": 1892,
	"./lightbulb.svg": 1893,
	"./linkedin.svg": 1894,
	"./menuBurger.svg": 1895,
	"./moneyHouseIcon.svg": 1896,
	"./pdf.svg": 1897,
	"./pen.svg": 1898,
	"./phone.svg": 1899,
	"./plus.svg": 1900,
	"./quoteLeft.svg": 1901,
	"./react-router.svg": 1902,
	"./react.svg": 1903,
	"./redux.svg": 1904,
	"./successHouseIcon.svg": 1905,
	"./successIcon.svg": 1906,
	"./suitcase.svg": 1907,
	"./trash.svg": 1908,
	"./upload.svg": 1909,
	"./userTie.svg": 1910,
	"./warningIcon.svg": 1911,
	"./webpack.svg": 1912,
	"./youtube.svg": 1913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1858;